import { useGetIdentityStatusQuery } from 'core/query/yapi/hk-web/RealPersonAuth/query'
import { useAuthenticate } from 'core/components/Authenticate'

export enum IdentityStatus {
  // 身份认证状态 0等待审核 1审核通过 2审核不通过 3未认证
  WaitAudit = 0,
  PassAudit = 1,
  FailAudit = 2,
  NotIdentified = 3,
}

export enum IdentityType {
  // 身份认证类型 0未认证 1个人标准认证 2个人高级认证 3企业认证
  NotIdentified = 0,
  PersonStandard = 1,
  PersonAdvanced = 2,
  Enterprise = 3,
}

export const verifys = [
  {
    title: '企业认证',
    key: 'verified_011',
    type: IdentityType.Enterprise,
    status: [IdentityStatus.PassAudit],
  },
  {
    title: '高级认证',
    key: 'verified_057',
    type: IdentityType.PersonAdvanced,
    status: [IdentityStatus.PassAudit],
  },
  {
    title: '标准认证',
    key: 'verified_056',
    type: IdentityType.PersonStandard,
    status: [IdentityStatus.PassAudit],
  },
  {
    title: '未认证',
    key: 'verified_053',
    type: IdentityType.NotIdentified,
    status: [IdentityStatus.FailAudit, IdentityStatus.NotIdentified],
  },
  {
    title: '认证中',
    key: 'hotcoinWeb_v1_22_56_CertificationInProgress',
    type: IdentityType.NotIdentified,
    status: [IdentityStatus.WaitAudit],
  },
]

/* 用户获取用户当前的认证状态 */
export const useIdentity = (enabled: boolean = false) => {
  const { loginData } = useAuthenticate()
  const { data: identityStatusData } = useGetIdentityStatusQuery(
    {},
    {
      enabled: !!loginData && enabled,
    }
  )
  const statusList = identityStatusData?.data?.data.statusList || []
  const defaultIdentity = {
    title: '未认证',
    key: 'verified_053',
    type: IdentityType.NotIdentified,
    status: [IdentityStatus.FailAudit, IdentityStatus.NotIdentified],
  }
  const inReview = statusList.findLast((item) => item.identityStatus === IdentityStatus.WaitAudit)
  /* 待审核 */
  if (inReview) {
    return {
      title: '认证中',
      key: 'hotcoinWeb_v1_22_56_CertificationInProgress',
      type: IdentityType.NotIdentified,
      status: [IdentityStatus.WaitAudit],
    }
  }
  /* 审核通过 */
  const passAudit = statusList.findLast((item) => item.identityStatus === IdentityStatus.PassAudit)
  if (passAudit) {
    return (
      verifys.find((item) => item.status.includes(IdentityStatus.PassAudit) && item.type === passAudit.identityType) ||
      defaultIdentity
    )
  }
  return defaultIdentity
}
